import { UnauthentifiedLayout } from '@layout';
import { LoginPage, WelcomePage, CompanyChoicePage } from '@pages';
import { Navigate } from 'react-router-dom';

import { RouteObject } from 'react-router-dom';

export const unauthentifiedRoutes = (isLogged: boolean | null | undefined): RouteObject[] => [
    {
        element: <UnauthentifiedLayout />,
        children: [
            {
                path: '/',
                element: isLogged ? <Navigate to="/home" replace /> : <WelcomePage />
            },
            {
                path: '/company-choice',
                element: isLogged ? <Navigate to="/home" replace /> : <CompanyChoicePage />
            },
            {
                path: '/login',
                element: isLogged ? <Navigate to="/home" replace /> : <LoginPage />
            },
            {
                path: '*',
                element: <Navigate to="/" replace />
            }
        ]
    }
];
